import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=602edcf0&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=602edcf0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602edcf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('602edcf0')) {
      api.createRecord('602edcf0', component.options)
    } else {
      api.reload('602edcf0', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=602edcf0&scoped=true", function () {
      api.rerender('602edcf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/business/Create.vue"
export default component.exports